/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.login.account-login.tab': '账号密码登录',
  'pages.login.account-login.error-message': '错误的用户名和密码',
  'pages.login.username.placeholder': '请输入用户名 / +区号 手机号 / 邮箱',
  'pages.login.username.required': '账号未填写',
  'pages.login.password.placeholder': '请输入登录密码',
  'pages.login.password.required': '密码未填写',
  'pages.login.phone-login.tab': '验证码登录',
  'pages.login.phone-login.error-message': '验证码错误',
  'pages.login.origin.placeholder': '请输入+区号 手机号 / 邮箱',
  'pages.login.origin.required': '手机号或邮箱未填写',
  'pages.login.origin.invalid': '请输入所在区号合法的手机号或正确的邮箱',
  'pages.login.captcha.placeholder': '请输入验证码',
  'pages.login.captcha.required': '验证码未填写',
  'pages.login.captcha.mistake': '验证码错误或已失效',
  'pages.login.phone.get-opt-code': '获取验证码',
  'pages.login.phone.get-opt-code.success': '获取验证码成功',
  'pages.login.phone.captcha-second-text': '秒后重新获取',
  'pages.login.remember-me': '自动登录',
  'pages.login.forgot-password': '忘记密码？',
  'pages.login.submit': '登录',
  'pages.login.license-tip.before': '登录即表示您接受',
  'pages.login.license-tip.software': '《社区软件许可协议》',
  'pages.login.license-tip.and': '与',
  'pages.login.license-tip.privacy': '《隐私协议》',
  'pages.login.login-with': '其他登录方式',
  'pages.login.register-account': '注册账户',
  'pages.login.forget-password': '重置密码',
  'pages.login.forget-password.desc':
    '请输入你注册的手机号/邮箱用于接收验证码，我们将为你重置密码。',
  'pages.login.forget-password.phone.placeholder': '请输入「+区号 手机号」 / 邮箱',
  'pages.login.forget-password.phone.required': '手机号或邮箱未填写',
  'pages.login.forget-password.phone.invalid': '请输入所在区号合法的手机号或正确的邮箱',
  'pages.login.forget-password.next-step': '下一步',
  'pages.login.forget-password.password.desc': '你正在重置 {phone} 的密码',
  'pages.login.forget-password.password.new': '请输入新密码',
  'pages.login.forget-password.password.confirm': '请确认新密码',
  'pages.login.forget-password.inconsistency': '两次密码不一致',
  'pages.login.forget-password.back-time': '后将自动跳转登录页',
  'pages.login.forget-password.success': '重置成功',
  'pages.login.forget-password.success.desc': '密码重置成功，你可以使用新密码继续登录',
  'pages.login.success-prompt': '登录成功！正在跳转...',
  'pages.login.bind-idp': '身份绑定',
  'pages.login.bind-idp.paragraph':
    '三方账户尚未绑定系统用户，请输入待绑定的用户名密码完成身份绑定。',
  'pages.login.bind-idp.form.submit-text': '绑定',
  'pages.login.bind-idp.form.username': '待绑定用户名',
  'pages.login.bind-idp.form.username.rule.0': '请输入待绑定用户名',
  'pages.login.bind-idp.form.username.placeholder': '请输入待绑定用户名',
  'pages.login.bind-idp.form.password': '密码',
  'pages.login.bind-idp.form.password.rule.0': '请输入待绑定账号密码',
  'pages.login.bind-idp.form.password.placeholder': '请输入待绑定账号密码',
  'pages.login.bind-idp.unable-bind': '无法绑定？请联系您的企业管理员。',
  'pages.login.bind-idp.bind-success': '绑定成功，正在跳转...',
  'pages.login.phone-login.get-verification-code': '获取验证码',
  'pages.login.reset_password_jumping': '该账号需进行重置密码，正在跳转...',
};
